import React, { useEffect, useState } from 'react';
import { Heading } from '@abyss/web/ui/Heading';
import { Router } from '@abyss/web/ui/Router';
import { usePageDataStore } from '@src/store/common/PageDataStore';
import { usePageTitleStore } from '@src/store/common/PageTitleStore';

export const PageTitle = () => {
  const [title, setTitle] = useState<string | undefined>(undefined);
  const pageData = usePageDataStore((state) => state.pageData);
  const pageTitle = usePageTitleStore((state) => state.pageTitle);

  useEffect(() => {
    if (pageData && 'pageTitle' in pageData) {
      setTitle(pageData.pageTitle as string);
    }
  }, [pageData]);

  useEffect(() => {
    if (pageTitle && 'title' in pageTitle) {
      setTitle(pageTitle.title as string);
    }
  }, [pageTitle]);

  return (
    <React.Fragment>
      <Router.MetaTags title={title} />
      <Heading
        display="h5"
        css={{
          fontSize: '18px',
          fontWeight: 700,
          lineHeight: 1.3,
          margin: '0',
        }}
      >
        {title}
      </Heading>
    </React.Fragment>
  );
};
